import Slider from "react-slick";
import { LazyLoadImage } from "react-lazy-load-image-component";
import noImage from "../../images/icons/noImage.png";
import loaderGif from "../../images/Loading_2.gif";

export default function ScreenSlider({ product }) {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
  };

  return (
    <div className="productScreen__img">
      <Slider {...settings}>
        {!product?.imageLinks[0] ? (
          <LazyLoadImage src={noImage} placeholderSrc={loaderGif} alt="NoImg" />
        ) : (
          product.imageLinks.map((img, index) => (
            <LazyLoadImage key={index + 1} src={img} placeholderSrc={loaderGif} alt={product.name} />
          ))
        )}
      </Slider>
    </div>
  );
}
